/**
 * Utility function to check if an email belongs to authorized domains
 * @param {string} email - The email address to check
 * @returns {boolean} - true if email is from authorized domains (@e2f.com or @trustscale.ai)
 */
export function isAuthorizedEmailDomain(email) {
    if (!email) return false;
    return email.includes('@e2f.com') || email.includes('@trustscale.ai');
}

/**
 * Utility function to check if an email is from internal/company domains
 * @param {string} email - The email address to check
 * @returns {boolean} - true if email is from internal domains (@e2f.com or @trustscale.ai)
 */
export function isInternalEmailDomain(email) {
    return isAuthorizedEmailDomain(email);
}
